import { Link } from '~/shared/components/Link';
import { default as M10HeroContent } from './components/M10HeroContent';
import { ModuleContainer } from '../../shared/ModuleContainer';
import { M10HeroProps } from './types';

export type { M10HeroProps } from './types';

export default function M10Hero({ spacingBottom, callToAction, ...rest }: M10HeroProps) {
    return (
        <ModuleContainer hasGutter spacingBottom={spacingBottom}>
            {callToAction ? (
                <Link href={callToAction.url} target={callToAction.target}>
                    <M10HeroContent callToAction={callToAction} {...rest} />
                </Link>
            ) : (
                <M10HeroContent callToAction={callToAction} {...rest} />
            )}
        </ModuleContainer>
    );
}
